import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface UpdateDashboardNoteParams {
    readonly id: number;
    readonly content: string;
    readonly version: string;
}

export type UpdateDashboardNoteResponse = {
    value: number,
    version: string,
};

export class UpdateDashboardNoteCommand extends Command<UpdateDashboardNoteParams, UpdateDashboardNoteResponse> { }

export class UpdateDashboardNoteCommandHandlerBase implements CommandHandler<UpdateDashboardNoteCommand, UpdateDashboardNoteParams, UpdateDashboardNoteResponse> {
    private static Url = TaggedUrl.join('user/notes/:id', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(cmd: UpdateDashboardNoteCommand): Promise<UpdateDashboardNoteResponse> {
        const { data } = await this.http.put(fillPlaceholders(UpdateDashboardNoteCommandHandlerBase.Url, { id: cmd.params?.id }), {
            content: cmd.params?.content,
            version: cmd.params?.version
        });
        return data;
    }
}
